import React from "react";
import IndustryPage from "./IndustryPage";

const EnergyPage: React.FC = () => {
  return <IndustryPage industryKey="energy" />;
};

export default EnergyPage;
